const styles = (checkoutTheme) => ({})

export default styles
